import { inject, injectable } from 'inversify';
import { type IBaseViewModel, SceneItemKind } from '@/engine/app/interfaces.ts';
import { TYPES } from '@/engine/ioc';
import type { ViewsService } from '@/engine/app/Views.service.ts';

export interface IEntitiesVisibilityTogglingService {
  toggleEntitiesVisibility: () => void;
}

@injectable()
export class EntitiesVisibilityTogglingService implements IEntitiesVisibilityTogglingService {
  private readonly _viewsService: ViewsService;

  private _workflowItems: Array<IBaseViewModel> = [];

  private _visibleContourItems: Array<IBaseViewModel> = [];

  private _isVisibilityToggled = false;

  public constructor(@inject(TYPES.ViewsService) viewsService: ViewsService) {
    this._viewsService = viewsService;
  }

  public toggleEntitiesVisibility(): void {
    if (!this._isVisibilityToggled) {
      this._workflowItems.push(
        ...(this._filterViewObjects() as Array<IBaseViewModel>),
        ...(this._filterViewMeasurements() as Array<IBaseViewModel>)
      );
      this._visibleContourItems = this._filterViewMeshObjects() || [];
    }

    this._workflowItems?.forEach((o: IBaseViewModel) => o.setVisibility(this._isVisibilityToggled));
    this._visibleContourItems.forEach((o: IBaseViewModel) => o.setContourVisibility(this._isVisibilityToggled));

    if (this._isVisibilityToggled) {
      this._workflowItems = [];
      this._visibleContourItems = [];
    }

    this._toggleVisibilityState();
  }

  private _filterViewObjects(): Array<IBaseViewModel> | undefined {
    return this._viewsService.currentView
      ?.getObjects()
      .filter((o: IBaseViewModel) => o.isVisible && o.kind !== SceneItemKind.Mesh);
  }

  private _filterViewMeshObjects(): Array<IBaseViewModel> | undefined {
    return this._viewsService.currentView?.getObjects().filter((o: IBaseViewModel) => o.isContourVisible);
  }

  private _filterViewMeasurements(): Array<IBaseViewModel> | undefined {
    return this._viewsService.currentView?.getMeasurements().filter((m: IBaseViewModel) => m.isVisible);
  }

  private _toggleVisibilityState(): void {
    this._isVisibilityToggled = !this._isVisibilityToggled;
  }
}
